import { TEAMS_ANNOTS_DATA, TEAMS_ENTRY_FROM } from "@/modules/queryData.types";

export enum ACCOUNT_REGION {
    US = 'US',
    EU = 'EU',
    CA = 'CA',
}

export type TEAMS_TAB_DATA = {
    entityId: string;
    channelId: string;
    groupId: string;
    tenantId: string;
}

export type TEAMS_NOTIFICATION_PARAMS = {
    entryFrom: TEAMS_ENTRY_FROM;
    reviewSessionID: string;
    teamsEmail: string;
    nickname: string;
    fileName: string;
    foxitUserName: string;
    region: ACCOUNT_REGION;
    type: string;
    annotType: string;
    commentText: string;
    annotData: TEAMS_ANNOTS_DATA;
    repliedUserName?: string;
    driveId?: string;
    fileId?: string;
    contentUrl?: string;
    chatUserId?: string;
    tabData?: TEAMS_TAB_DATA;
}
